import {push} from 'connected-react-router/immutable';
import {getCurrentCompanyId} from '../reducers/companies';
import {createRepo} from '../services/repo';
import {NOT_FOUND, TEST, QUESTIONNAIRE360} from '../services/routes';
import {i18n} from '../services/i18n';

const testsRepo = createRepo({
  modelName: 'test',
  plural: 'tests',
  endpoint: 'usertests',
  isGlobal: true,
  getCurrentCompanyId,
  validateNewItemData({name}) {
    if (!name) {
      return i18n._('tests.no_valid_test', {}, {defaults: 'No valid Test name'});
    }

    return null;
  },
  buildNewItemData({name, TestId}) {
    return {
      name,
      TestId,
    };
  },
});

export const {testsLoadingSuccess, loadTestsFromRepo, loadTestFromRepo} = testsRepo.actionCreators;

export function loadTests() {
  return loadTestsFromRepo;
}

export function loadTest(id, redirect = true) {
  return function(dispatch, getState) {
    loadTestFromRepo(id, dispatch, getState).catch(error => {
      if (error && redirect) {
        dispatch(push(NOT_FOUND));
      }
    });
  };
}

export const SET_CURRENT_TEST = 'SET_CURRENT_TEST';

export function setCurrentTest(data) {
  return {
    type: SET_CURRENT_TEST,
    data,
  };
}

export const START_TEST = 'START_TEST';

export function startTest({testIs360}) {
  return function(dispatch) {
    dispatch(setTestingItem());

    testIs360 ? dispatch(push(QUESTIONNAIRE360)) : dispatch(push(TEST));
  };
}

export function setTestingItem() {
  return {
    type: START_TEST,
  };
}

export const STOP_TEST = 'STOP_TEST';

export function stopTestingItem() {
  return {
    type: STOP_TEST,
  };
}
